import { Controller } from "@hotwired/stimulus";

// Submits the form this controller is attached to whenever a child input
// fires the `submit` action (e.g. a select with data-action="change->submit-on-change#submit").
export default class extends Controller {

  submit() {
    this.element.requestSubmit();
  }

}
